// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"be317e1e","154":"838b4efd","213":"efeb02ae","455":"ff240478","469":"97f04ca1","557":"bc2479b6"}[chunkId] + ".chunk.js";
};